import { PureComponent, Fragment } from 'react';
import Head from 'components/Head';
import { getMeta } from 'constants/meta';
import LoginHeader from './LoginHeader';

const SUCCESS_PROPS = {
  title: 'Check Your Email Now!',
  text: 'We have sent you a password reset link.',
  showIcon: true,
};

class SuccessForm extends PureComponent {
  componentDidMount() {
    this.interval = setTimeout(() => this.props.history.push('/login'), 5000);
  }

  componentWillUnmount() {
    clearTimeout(this.interval);
  }

  render() {
    const { location } = this.props;
    const { title, description } = getMeta(location.pathname);
    return (
      <Fragment>
        <Head title={title} description={description} />
        <LoginHeader {...SUCCESS_PROPS} />
      </Fragment>
    );
  }
}

export default SuccessForm;
